import { JOB_UPLOAD_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(JOB_UPLOAD_ENDPOINT);
export default instance;
